import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import ScheduleServices from "../services/ScheduleServices";
import { notifyError, notifySuccess } from "../utils/toast"; 
import dayjs from "dayjs";
import { allContext } from "../context/AllContext";

const useScheduleSubmit = (id) => { 
  const [viewData, setviewData] = useState([]);  
  const [isModal, setIsModal] = useState(false);  
  const [isViewModal, setIsViewModal] = useState(false); 
  const [isConfirmModal, setIsConfirmModal] = useState(false); 
  const [status, setStatus] = useState("Active");
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const { dataUpdate, setDataUpdate } = useContext(allContext);
  const [imageUrl, setImageUrl] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    // clearErrors,
    // reset,
    formState: { errors },
  } = useForm();
 

  const onSubmit = async (scheduleData) => {
    try {     
        
      if (id) {  
        scheduleData.status = status;
        const res = await ScheduleServices.updateSchedule(id, scheduleData);
        notifySuccess(res.message);
        setDataUpdate(!dataUpdate);
        setIsModal(false);
      } else {
        scheduleData.status = "Need to Approach";
        const res = await ScheduleServices.addSchedule(scheduleData);
        notifySuccess(res.message);
        setIsModal(false);  
        setDataUpdate(!dataUpdate);  
        // window.location.reload();
      }  
      return;
    } catch (err) { 
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };  

  const deleteSchedule = async (schedule_id) => {
      const result = await ScheduleServices.deleteSchedule(schedule_id);
      notifySuccess(result?.message); 
      setIsDeleteModal(false);
      setDataUpdate(!dataUpdate); 
  }

  const ShowEditValues = async (row, type) => {   
    const result = await ScheduleServices.getScheduleById(row._id);
    var resdata = result?.data;
    // console.log(" edit ", result);
    if(result?.success === true) {
      if(type === "Edit") {   
        setValue("employeeId", resdata?.employeeId?._id);
        setValue("clientId", resdata?.clientId?._id);
        setValue("projectType", resdata?.projectType?._id);
        setValue("scheduleDate", dayjs(resdata?.scheduleDate).format("YYYY-MM-DD"));   
        setValue("fromTime", resdata?.fromTime);
        setValue("toTime", resdata?.toTime);
        setValue("status", resdata?.status);   
        setStatus(resdata?.status);
      }else { 
        setviewData(resdata);
      }
    }     
  } 
  
  const changeStatusRequest = async (ScheduleId) => {  
    const result = await ScheduleServices.updateScheduleStatus(ScheduleId, {"status":"Request"});
    var resdata = result?.message; 
    notifySuccess(resdata);
  }

  const changeStatusConfirm = () => { 
    setIsConfirmModal(true); 
  }

  const handleConfirmSchedule = async (ScheduleId) => {
    const result = await ScheduleServices.updateScheduleStatus(ScheduleId, {"status":"Confirm", "confirmedReqFile": imageUrl});
    var resdata = result?.message;
    notifySuccess(resdata);
    setIsConfirmModal(false);
  } 

  useEffect(() => {
    // console.log(" id == ", id);
    if(!id) {
      setValue("employeeId", "");
      setValue("clientId", "");
      setValue("projectType", "");
      setValue("scheduleDate", "");   
      setValue("fromTime", "");
      setValue("toTime", "");
      setValue("status", ""); 
      setStatus("");
    }
  }, [id])
  
  return {
    register,
    handleSubmit,
    onSubmit, 
    errors,
    setviewData,
    viewData,
    deleteSchedule,
    isModal, setIsModal, 
    ShowEditValues,
    isViewModal, setIsViewModal,
    status, setStatus,
    changeStatusRequest, changeStatusConfirm,
    isConfirmModal, setIsConfirmModal, handleConfirmSchedule,
    isDeleteModal, setIsDeleteModal,
    imageUrl, setImageUrl
  };
};

export default useScheduleSubmit;
